import axios from "../httpClient";

export const getDomains = async () => axios.get(`/mailbox/domains`);

export const createApplicantMailbox = async (applicantId, zendeskId) => axios.post(`/mailbox/createApplicantMailbox`, {
    applicantId,
    zendeskId
  });
